import React, { useEffect } from "react";
import Styles from "./logout.module.css";
import { Box, Button } from "@sainsburys-tech/fable";
import userManager from "../../utils/userManager";
import Headerfile from "../common/Headerfile";

const Logout = () => {
  useEffect(() => {
    localStorage.clear();
    localStorage.removeItem("isLogout");
  }, []);

  const handleSSOLogin = () => {
    try {
      userManager
        .signinRedirect()
        .then(() => {
          console.log("Success");
        })
        .catch((err) => {
          console.log(err, "Error");
        });
    } catch (err) {
      console.log(err, "Error");
    }
  };
  return (
    <div className={Styles.container}>
      <Headerfile />

      <Box as="div" className={Styles.boxContainer}>
        <div className="App">
          <span className={Styles.firstSpan}>
            You've been successfully logged out from SmartPrint!
          </span>
          <br />
          <br />
          <span className={Styles.secondSpan}>
            Please click on <strong>Continue</strong> to Signin again...
          </span>
          <Button
            type="submit"
            style={{ width: "100%" }}
            className="my-5"
            onClick={() => handleSSOLogin()}
          >
            Continue
          </Button>
        </div>
      </Box>
    </div>
  );
};

export default Logout;
